import React from 'react';
import { apiClient } from '../lib/api/client';

export type JobTicket = {
  id: string;
  type: string;
  status: string;
  progress?: number;
  anchors?: any;
  resume_url?: string;
  result_url?: string;
  updated_at?: number;
};

type JobContextType = {
  jobs: JobTicket[];
  addLocal(jobId: string): void;
  removeLocal(jobId: string): void;
  refresh(): Promise<void>;
};

export const JobContext = React.createContext<JobContextType | null>(null);

const LOCAL_KEY = 'pending_job_ids';

export const JobProvider: React.FC<{ children: React.ReactNode; userId?: string }>=({ children, userId })=>{
  const [jobs, setJobs] = React.useState<JobTicket[]>([]);

  const readLocal = (): string[] => {
    try { return JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]'); } catch { return []; }
  };
  const writeLocal = (ids: string[]) => localStorage.setItem(LOCAL_KEY, JSON.stringify(Array.from(new Set(ids))));

  const addLocal = (jobId: string) => { const ids = readLocal(); ids.unshift(jobId); writeLocal(ids); };
  const removeLocal = (jobId: string) => { const ids = readLocal().filter(id => id !== jobId); writeLocal(ids); };

  const refresh = React.useCallback(async ()=>{
    if (!userId) return;
    try{
      const res = await apiClient.jobsList(userId, undefined, 50);
      setJobs(res.jobs as JobTicket[]);
    }catch(e){ console.warn('Job refresh failed', e); }
  },[userId]);

  React.useEffect(()=>{ refresh(); /* const i = setInterval(refresh, 15000); return ()=> clearInterval(i); */ },[refresh]);

  const value: JobContextType = { jobs, addLocal, removeLocal, refresh };
  return <JobContext.Provider value={value}>{children}</JobContext.Provider>;
};

export const useJobs = () => {
  const ctx = React.useContext(JobContext);
  if (!ctx) throw new Error('useJobs must be used within JobProvider');
  return ctx;
};


